/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultMessage
 */
export interface ResultMessage {
    /**
     * 
     * @type {string}
     * @memberof ResultMessage
     */
    message?: string;
}

/**
 * Check if a given object implements the ResultMessage interface.
 */
export function instanceOfResultMessage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResultMessageFromJSON(json: any): ResultMessage {
    return ResultMessageFromJSONTyped(json, false);
}

export function ResultMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ResultMessageToJSON(value?: ResultMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

